module.exports = __webpack_public_path__ + "static/media/large-event-banner.2b16195b.png";